import { PatientMedicine } from '@dreryk/egabinet-prescription-frontend-api';

import { ContinuouslyUsedMedicineIcon, IconFillColor, Tooltip } from '@dreryk/react-components';

import { translationKeys } from '../../translations';

import { StyledAddContinuouslyUsedMedicineIconWrapper } from './AddContinuouslyUsedMedicineButton.styled';
import { useCreateContinuouslyUsedMedicine } from './useCreateContinuouslyUsedMedicine';

type AddContinuouslyUsedMedicineButtonProps = {
   readonly patientId: number;
   readonly medicine: PatientMedicine['medicine']['id'];
   readonly onMedicineAdded: (id: PatientMedicine['patientContinuouslyUsedMedicineId'] | undefined) => void;
   readonly disabled?: boolean;
};

const AddContinuouslyUsedMedicineButton = (props: AddContinuouslyUsedMedicineButtonProps): JSX.Element => {
   const {
      execute: addContinuouslyUsedMedicine,
      loading: addContinuouslyUsedMedicineLoading,
   } = useCreateContinuouslyUsedMedicine(props.patientId, props.medicine, props.onMedicineAdded);

   const handleClick = (): void => {
      if (!props.disabled && !addContinuouslyUsedMedicineLoading) {
         addContinuouslyUsedMedicine();
      }
   };

   return (
      <Tooltip
         testId={'addContinuouslyUsedMedicine'}
         content={
            props.disabled
               ? translationKeys.medicine.continuouslyUsedMedicine.cannotAddWithdrawnMedicineToContinuouslyUsedMedicines
               : translationKeys.medicine.continuouslyUsedMedicine.addMedicineToContinuouslyUsedMedicines
         }
      >
         <StyledAddContinuouslyUsedMedicineIconWrapper
            onClick={handleClick}
            fillColor={IconFillColor.PRIMARY_LIGHTER}
            disabled={props.disabled}
            testId={'addContinuouslyUsedMedicine'}
         >
            <ContinuouslyUsedMedicineIcon />
         </StyledAddContinuouslyUsedMedicineIconWrapper>
      </Tooltip>
   );
};

export { AddContinuouslyUsedMedicineButton };
